export default "__VITE_ASSET__Dlk6DmKW__"